/**
 * Missions: three at a time; finish all three to level up. Rewards are paid into the wallet by the server.
 */
export type MissionMetric =
  | 'passengersCarried'
  | 'passengersDropped'
  | 'perfectStops'
  | 'closeCalls'
  | 'faresPesewas'
  | 'cleanJunctions'
  | 'metres';

export interface MissionTemplate {
  id: string;
  metric: MissionMetric;
  /** Target at level 1, and how much it grows per level. */
  base: number;
  perLevel: number;
  /** Shown to the player; {n} is the target. */
  text: string;
  /** Counted within a single shift, or across shifts. */
  scope: 'shift' | 'total';
}

export const MISSION_TEMPLATES: readonly MissionTemplate[] = [
  { id: 'carry', metric: 'passengersCarried', base: 8, perLevel: 3, text: 'Carry {n} passengers in one shift', scope: 'shift' },
  { id: 'drop', metric: 'passengersDropped', base: 12, perLevel: 6, text: 'Drop {n} passengers at their stop', scope: 'total' },
  { id: 'perfect', metric: 'perfectStops', base: 3, perLevel: 2, text: 'Make {n} perfect stops in one shift', scope: 'shift' },
  { id: 'close', metric: 'closeCalls', base: 3, perLevel: 2, text: 'Get {n} close calls in one shift', scope: 'shift' },
  { id: 'earn', metric: 'faresPesewas', base: 5000, perLevel: 4000, text: 'Earn GH₵{n} in fares', scope: 'total' },
  { id: 'lights', metric: 'cleanJunctions', base: 3, perLevel: 2, text: 'Pass {n} junctions without jumping a red', scope: 'shift' },
  { id: 'distance', metric: 'metres', base: 3000, perLevel: 1500, text: 'Drive {n} m in one shift', scope: 'shift' },
];

export function missionTarget(template: MissionTemplate, level: number): number {
  return template.base + template.perLevel * (level - 1);
}

/** Reward for one mission at this level, pesewas. */
export function missionReward(level: number): number {
  return 1000 + 600 * (level - 1);
}

/** The server pays at most this many missions per shift. */
export const MAX_MISSIONS_PER_SHIFT = 3;
